export function tableConfig (getMoney) {
  return {
      menuType: "button",
      addBtn: false,
      menuWidth: 120,
      menuAlign: "center",
      card: true,
      menu: false,
      delBtn: false,
      editBtn: false,
      align: "center",
      searchMenuSpan: 8,
      columnBtn: false,
      searchBtn: true,
      index: true,
      indexLabel: "序号",
      indexWith: 35,
      refreshBtn: true,
      selection: true,
      selectionWidth: 30,
      searchShow: false,
      showSummary: true,
      column: [
        {
          label: "搜索查询",
          searchPlaceholder: "基金编号/基金名称",
          placeholder: "基金编号/基金名称",
          prop: "search1",
          hide: true,
          display: true,
          search: true,
          hideshow: true,
        },
        // {
        //   sortable: "custom",
        //   label: "基金编号",
        //   prop: "number",
        //   width: "120",
        //   fixed: true
        // },
        {
          label: "基金名称",
          prop: "name",
          // width: "140",
          slot: true,
          // fixed: true
        },
        {
          label: "投资/退出明细",
          bind: "fundDetail",
          prop: "fundDetail",
          width: 90,
          slot: true,
        },
        // {
        //   label: "审核状态",
        //   prop: "auditState",
        //   width: "70",
        //   type: "select",
        //   search: true,
        //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
        //   props: {
        //     label: "dictValue",
        //     value: "dictKey"
        //   }
        // },
        {
          label: "设立时间",
          width: "80",
          prop: "establishmentTime",
        },
        {
          label: "基金规模(万元)",
          prop: "peScale",
          width: "100",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }

        },
        {
          label: "基金实缴金额(万元)",
          prop: "totalCapitalPaid",
          width: "125",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }
        },
        // {
        //   label: "政府产业基金认缴规模",
        //   prop: "govIndustrySubscribed",
        //   width: "160",
        //   formatter: (row, value, label, column) => {
        //     if (value == -1) {
        //       return "-";
        //     } else {
        //       return getMoney(value)+' 元';
        //     }
        //   }
        // },
        {
          label: "基金已投金额(万元)",
          prop: "allFundAmount",
          width: "130",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }
        },
        //  {
        //   label: "出资比例",
        //   prop: "capitalRatio",
        //   width: "80",
        //   formatter: (row, value, label, column) => {
        //     if (value == -1) {
        //       return "-";
        //     } else {
        //       return getMoney(value) +' %';
        //       }
        //   }
        // },
         {
          label: "产业基金实缴额(万元)",
          prop: "govIndustryPaid",
          width: "145",
          formatter: (row, value, label, column) => {
            if (value == -1) {
              return "-";
            } else {
              return getMoney(Math.round(Number(value)/10000*100)/100);
            }
          }
        },

        {
          label: "基金管理人",
          prop: "managerName",
          search: false,
          width:200
        },
        {
          label: "经办人",
          prop: "managerUserName",
          width:50
        }
      ]
    }
}

export function examConfig(getMoney){
  return{
    menuType: "button",
    addBtn: false,
    menuWidth: 95,
    menuAlign: "center",
    card: true,
    refreshBtn:false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    column: [
      {
        label: "搜索查询",
        searchPlaceholder: "基金编号/基金名称",
        placeholder: "基金编号/基金名称",
        prop: "search1",
        hide: true,
        display: true,
        search: true,
        hideshow: true,
      },
      {
        sortable: "custom",
        label: "基金编号",
        prop: "number",
        width: "120",
        fixed: true
      },
      {
        label: "基金名称",
        prop: "name",
        width: "180",
        fixed: true
      },
      {
        label: "设立时间",
        width: "180",
        prop: "establishmentTime",

      },
      {
        label: "基金规模",
        prop: "peScale",
        width: "160",
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return  getMoney(value)+' 元';
          }
        }

      },
      {
        label: "基金实缴金额",
        prop: "totalCapitalPaid",
        width: "160",

        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return  getMoney(value)+' 元';
          }
        }
      },  {
        label: "基金已投金额",
        prop: "allFundAmount",
        width: "160",
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return  getMoney(value)+' 元';
          }
        }
      },
       {
        label: "政府产业基金出资比例",
        prop: "capitalRatio",
        width: "160",
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return getMoney(value) +' %';
            }
        }
      },
       {
        label: "政府产业基金实缴额",
        prop: "govIndustryPaid",
        width: "160",
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return  getMoney(value)+' 元';
          }
        }
      },

      {
        label: "基金管理人",
        prop: "managerName",
        width: "100",
        search: false,
      },
      {
        label: "基金协会编码",
        prop: "orgCode",
        width: "180"
        // contactPhone
      },

      {
        label: "基金对接人",
        prop: "managerUserName"
      }
    ]
  }

}

export function tableOneConfig(getMoney){
  return [
    {
      label: '日期',
      prop: 'eventTime',
    },{
      label: '轮次',
      prop: 'investRound',
      formatter: (value) => {
        return value?`第${value}轮`:'/'
      }      
    },{
      label: '领投/跟投',
      prop: 'leader',
      formatter: (value) => {
        return value == 0?'领投': '跟投'
      }
    },{
      label: '本轮基金投资成本',
      prop: 'investCost',
      formatter: (value) => {
        return getMoney(Number(value).toFixed(2))
      }
    },
    // {
    //   label: '经办人',
    //   prop: 'managerUserName'
    // }
  ]
}

export function tableTwoConfig(getMoney){
  return [
    {
      label: '日期',
      prop: 'eventTime',
    },{
      label: '轮次',
      prop: 'quitInvestRound',
      formatter: (value) => {
        return value?`第${value}轮`:'/'
      }
    },{
      label: '领投/跟投',
      prop: 'leader',
      formatter: (value) => {
        return value == 0?'领投': '跟投'
      }
    },{
      label: '本轮基金退出金额',
      prop: 'quitAmount',
      formatter: (value) => {
        return getMoney(Number(value).toFixed(2))
      }
    },{
      label: '本轮基金投资收益',
      prop: 'income',
      formatter: (value) => {
        return getMoney(Number(value).toFixed(2))
      }      
    },
    // {
    //   label: '经办人',
    //   prop: 'managerUserName'      
    // }
  ]
}

export function tableThreeConfig(getMoney){
  return [
    {
      label: '日期',
      prop: 'eventTime',
    },{
      label: '分红金额',
      prop: 'bonusAmount',
      formatter: (value) => {
        return getMoney(Number(value).toFixed(2))
      }      
    },
    // {
    //   label: '经办人',
    //   prop: 'managerUserName'      
    // }
  ]
}

const LEADER = [{
  label: '领投',
  value: 0
},{
  label: '跟投',
  value: 1
}]
const INVEST_TYPE = [
  {
    dictValue: '增投',
    dictKey: 1
  },{
    dictValue: '转老股',
    dictKey: 2
  },{
    dictValue: '定增',
    dictKey: 3
  },{
    dictValue: '其它',
    dictKey: 4
  }
]
export function investEventConfig(isvalidateMoney) {
  return {
    // 投资事件
    stockRightConfig: {
      labelWidth: 220,
      gutter: 20,
      submitBtn: false,
      emptyBtn: false,
      column: [
        {
          label: '日期',
          type: 'date',
          prop: 'eventTime',
          format:'yyyy-MM-dd',
          valueFormat:'yyyy-MM-dd',
          span: 12,
          rules: [{
            required: true,
            message: '请选择日期',
            trigger: 'change'
          }]
        },
        {
          label: '投资方式',
          type: 'select',
          span: 12,
          dicUrl: "/api/blade-system/dict-biz/dictionary?code=invest_type",
          // dicData: INVEST_TYPE,
          // dicData: [],
          props: {
            label: 'dictValue',
            value: 'dictKey'
          },
          prop: 'investType',
          rules: [{
            required: true,
            message: '请选择投资方式',
            trigger: 'change'
          }]
        },
        {
          label: '轮次',
          prop: 'investRound',
          // rules: [{
          //   required: true,
          //   message: '请输入轮次',
          //   trigger: 'input'
          // }]
        },
        {
          label: '领投/跟投',
          type: 'select',
          prop: 'leader',
          dicUrl: "/api/blade-system/dict-biz/dictionary?code=leader_type",
          props: {
            label: 'dictValue',
            value: 'dictKey'
          },
          rules: [{
            required: true,
            message: '请选择领投/跟投',
            trigger: 'change'            
          }]
        },
        {
          label: '股本类型',
          type: 'input',
          span: 12,
          prop: 'stockType'
        },
        {
          label: '投资标签',
          type: 'input',
          span: 12,
          prop: 'investTag'
        },
        {
          label: '本轮基金投资成本',
          prop: 'investCost',
          // type: 'input',
          formslot: true,
          // change: changeNumMoney,
          span: 12,
          rules: [{
              required: true,
              message: '请输入本轮基金投资成本',
              trigger: 'blur'
            },
            { validator: isvalidateMoney, trigger: "blur" }
          ]
        },
        {
          label: '本轮投后持有注册资本/股数',
          type: 'input',
          span: 12,
          prop: 'stockAmount',
          // rules: [{
          //   required: true,
          //   message: '请输入本轮投后持有注册资本/股数',
          //   trigger: 'input'             
          // }]
        },
        {
          label: '本轮投后企业总注册资本/股数',
          type: 'input',
          span: 12,
          prop: 'stockTotal',
          // rules: [{
          //   required: true,
          //   message: '请输入本轮投后企业总注册资本/股数',
          //   trigger: 'input'             
          // }]
        },
        {
          label: '本轮投后持股比例',
          formslot: true,
          span: 12,
          prop: 'stockRatio',
          unit: '%'
          // rules: [{
          //   required: true,
          //   message: '请输入本轮投后持股比例',
          //   trigger: 'input'             
          // }]
        },
        {
          label: '附件',
          prop: 'files',
          formslot: true,
          slot: true
          // rules: [{
          //   required: true,
          //   message: '请上传附件',           
          // }]
        },                
      ]
    },

    // 退出事件
    quitConfig: {
      labelWidth: 160,
      gutter: 20,
      submitBtn: false,
      emptyBtn: false,
      column: [
        {
          label: '日期',
          type: 'date',
          prop: 'eventTime',
          format:'yyyy-MM-dd',
          valueFormat:'yyyy-MM-dd',
          span: 12,
          rules: [{
            required: true,
            message: '请选择日期',
            trigger: 'change'
          }]
        },
        {
          label: '轮次',
          prop: 'investRound',
          span: 12,
          rules: [{
            required: true,
            message: '请输入轮次',
            trigger: 'input'
          }]
        },
        {
          label: '退出方式',
          type: 'select',
          span: 12,
          dicUrl: "/api/blade-system/dict-biz/dictionary?code=fd_event_quit_type",
          props: {
            label: 'dictValue',
            value: 'dictKey'
          },
          prop: 'quitType',
          rules: [{
            required: true,
            message: '请选择领投/跟投',
            trigger: 'input'
          }]
        },
        {
          label: '本轮基金退出成本',
          prop: 'quitCost',
          formslot: true,
          rules: [{
              required: true,
              message: '请输入本轮基金退出成本',
              trigger: 'input'
            },
            { validator: isvalidateMoney, trigger: "blur" }
          ]
        },
        {
          label: '本轮基金投资收益',
          prop: 'income',
          formslot: true,
          rules: [{
            required: true,
            message: '请输入本轮基金投资收益',
            trigger: 'input'
          },
          { validator: isvalidateMoney, trigger: "blur" }
          ]
        },        
        {
          label: '退出金额',
          prop: 'quitAmount',
          // prop: 'eventQuitAmount',
          span: 12,
          formslot: true,
          rules: [{
              required: true,
              message: '请输入退出金额',
              trigger: 'input'
            },{ validator: isvalidateMoney, trigger: "blur" }
          ]
        },
        {
          label: '附件',
          prop: 'files',
          span: 24,
          formslot: true,
          slot: true
          // rules: [{
          //   required: true,
          //   message: '请上传附件',           
          // }]
        },                
      ]
    },

    // 分红
    bonusConfig: {
      labelWidth: 140,
      gutter: 20,
      submitBtn: false,
      emptyBtn: false,
      column: [
        {
          label: '日期',
          type: 'date',
          prop: 'eventTime',
          format:'yyyy-MM-dd',
          valueFormat:'yyyy-MM-dd',
          span: 12,
          rules: [{
            required: true,
            message: '请选择日期',
            trigger: 'change'
          }]
        },
        {
          label: '分红金额',
          prop: 'bonusAmountStr',
          formslot: true,
          span: 12,
          rules: [{
            required: true,
            message: '请输入分红金额',
            trigger: 'input'
          },{ validator: isvalidateMoney, trigger: "blur" }]
        },
        {
          label: '附件',
          prop: 'files',
          span: 24,
          formslot: true,
          slot: true
          // rules: [{
          //   required: true,
          //   message: '请上传附件',           
          // }]
        },
      ]
    }
  }
}

export function stockRightConfig() {
  return [
    {
      label: '日期',
      prop: 'eventTime',
      span: 12,
    },{
      label: '投资方式',
      prop: 'investTypeStr',
      span: 12,
    },{
      label: '轮次',
      prop: 'investRound',
      span: 12,
    },{
      label: '领投/跟投',
      prop: 'leader',
      span: 12,
      formatter: (label, value)=> {
        return value == 0?'领投': '跟投'
      }
    },{
      label: '股本类型',
      prop: 'stockType',
      span: 12,
    },{
      label: '投资标签',
      prop: 'investTag',
      span: 12,
    },{
      label: '本轮基金投资成本',
      prop: 'investCostStr',
      span: 12,
      unit: '元'
    },{
      label: '本轮投后持有注册资本/股数',
      prop: 'stockAmount',
      span: 12,
      unit: '股'
    },{
      label: '本轮投后持股比例',
      prop: 'stockRatio',
      span: 24,
      unit: '%'
    },{
      label: '附件',
      prop: 'files',
      span: 24,
      slot: true
    }
  ]
}

export function quitConfig() {
  return [
    {
      label: '日期',
      prop: 'eventTime',
      span: 12,
    },{
      label: '轮次',
      prop: 'investRound',
      span: 12,
    },{
      label: '退出方式',
      prop: 'quitTypeStr',
      span: 12,
    },{
      label: '本轮基金退出成本',
      prop: 'quitCost',
      span: 12,
      unit: '元'
    },{
      label: '本轮基金投资收益',
      prop: 'income',
      span: 12,
      unit: '元'
    },{
      label: '退出金额',
      prop: 'quitAmount',
      span: 12,
      unit: '元'
    },{
      label: '附件',
      prop: 'files',
      span: 24,
      slot: true
    }
  ]
}

export function bonusConfig() {
  return [
    {
      label: '日期',
      prop: 'eventTime',
      span: 12,
    },{
      label: '分红金额',
      prop: 'bonusAmountStr',
      span: 12,
      unit: '元'      
    },{
      label: '附件',
      prop: 'files',
      span: 24,
      slot: true
    }    
  ]
}